import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductGroup from '../../models/ProductGroup'

export interface ProductGroupListState extends PaginatedApiState {
  productGroups?: ProductGroup[] 
}

const ProductGroupList = (state: ProductGroupListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductGroupListState>('PRODUCTGROUP_LIST')(state, action)
  }
}

export default ProductGroupList
